import { LoadingModal } from "@portal/components/layout/LoadingModal";
import { Card, Text } from "@portal/components/primitives";
import type { ReactNode, RefObject } from "react";

const IndemnityCardSection = ({
	title,
	testId,
	children,
}: {
	title?: string;
	testId: string;
	children: ReactNode;
}) => (
	<div className="flex w-full flex-col space-y-5" data-testid={testId}>
		{title && (
			<Text type="title" color="primary">
				{title}
			</Text>
		)}
		{children}
	</div>
);

export const IndemnityAgreementSectionLayout = ({
	signatureMethod,
	requiredIndemnitors,
	status,
	body,
	bodyTitle,
	bodyTestId,
	domReadyRef,
	loading,
}: {
	signatureMethod: ReactNode;
	requiredIndemnitors: ReactNode;
	status?: ReactNode;
	body?: ReactNode;
	bodyTitle?: string;
	bodyTestId?: string;
	domReadyRef: RefObject<HTMLDivElement | null>;
	loading?: boolean;
}) => {
	return (
		<div ref={domReadyRef} id="indemnity" className="flex flex-col w-full space-y-4">
			<div
				className="flex items-center space-x-[10px]"
				data-testid="agent-account-indemnity-header"
			>
				<Text type="heading" color="primary" className="flex-1">
					Indemnity
				</Text>
				{status}
			</div>
			<form>
				<Card elevation="raised" className="rounded-xl" data-testid="agent-account-indemnity-card">
					<Card.Body className="flex w-full flex-col space-y-8 p-6">
						<IndemnityCardSection
							title="Signature Method"
							testId="agent-account-signature-method-card"
						>
							{signatureMethod}
						</IndemnityCardSection>
						<IndemnityCardSection
							title="Required Indemnitors"
							testId="agent-account-required-indemnitors-card"
						>
							{requiredIndemnitors}
						</IndemnityCardSection>
						{body !== undefined && (
							<IndemnityCardSection
								title={bodyTitle}
								testId={bodyTestId ?? "agent-account-indemnity-body"}
							>
								{body}
							</IndemnityCardSection>
						)}
					</Card.Body>
				</Card>
			</form>
			{loading && <LoadingModal />}
		</div>
	);
};
